// @ts-nocheck

import { type ObjectValuesUnionType } from '../../../utils/typing';
import { BoomSkinIds } from '../types/global';

export const BoomStorageKeyTypes = Object.freeze({
  HOME_ANIMATION_BEEN_VIEWED: 'HOME_ANIMATION_BEEN_VIEWED',
  WELCOME_BEEN_VIEWED: 'WELCOME_BEEN_VIEWED',
});
export type BoomStorageKeyType = ObjectValuesUnionType<typeof BoomStorageKeyTypes>;

const BoomStorageValuesByKeyTypes = Object.freeze({
  [BoomStorageKeyTypes.HOME_ANIMATION_BEEN_VIEWED]: 'homeAnimationViewed',
  [BoomStorageKeyTypes.WELCOME_BEEN_VIEWED]: 'welcomeViewed',
});

export const getBoomStorageKey = (boomId: string, keyType: BoomStorageKeyType) =>
  `BOOM_${boomId?.toUpperCase() ?? ''}_${keyType}`;

export const getBoomStorageValue = (boomId: string, keyType: BoomStorageKeyType) =>
  `application:betting:boom_${boomId?.toLowerCase() ?? ''}:${BoomStorageValuesByKeyTypes[keyType] ?? ''}`;

export const BoomKeys: { [key: string]: string } = Object.freeze(
  Object.keys(BoomSkinIds).reduce(
    (acc, skinId) => ({
      ...acc,
      ...Object.keys(BoomStorageKeyTypes).reduce(
        (_acc, keyType) => ({
          ..._acc,
          [getBoomStorageKey(skinId, keyType)]: getBoomStorageValue(skinId, keyType),
        }),
        {},
      ),
    }),
    {},
  ),
);
